import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { EmailLog } from 'src/app/core/models/email-log';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DomSanitizer } from '@angular/platform-browser';

    import { AfterViewInit, ElementRef } from '@angular/core';

@Component({
    selector: 'app-show-email',
    templateUrl: './show-email.component.html',
    styleUrls: ['./show-email.component.scss'],
    standalone: true,

})
export class ShowEmailComponent implements OnInit {
    @Input() public emailLog: EmailLog;

    constructor(private activeModal: NgbActiveModal, private sanitizer: DomSanitizer) { }

    public ngOnInit() {
    }

    public close() {
        this.activeModal.close();
    }






}
